document.addEventListener('DOMContentLoaded', function () {
  const menu = document.getElementById('as-article_menu');
  const body = document.querySelector('.as-article__body');

  if (!body || !menu) return;

  // TOC Generation
  const headings = Array.from(body.querySelectorAll('h2'));
  menu.innerHTML = '';

  headings.forEach((h, index) => {
    const text = h.textContent.trim();
    if (!text) return;

    const id = text.replace(/ /g, '-').replace(/[^\w\-]/gi, '');
    h.id = id;

    const li = document.createElement('li');
    li.className = `toc-${id}`;
    li.innerHTML = `<a href="#${id}" title="${text}">${index + 1}. ${text}</a>`;
    menu.appendChild(li);
  });

  // scroll-based highlight logic
  function onScrollHighlightTOC() {
    const headings = Array.from(
      document.querySelectorAll('.as-article__body h2')
    );
    const tocItems = document.querySelectorAll('#as-article_menu li');
    let currentHeadingId = null;
    let minDistance = window.innerHeight;

    headings.forEach(heading => {
      const rect = heading.getBoundingClientRect();
      if (rect.top >= 0 && rect.top < minDistance) {
        minDistance = rect.top;
        currentHeadingId = heading.id;
      }
    });

    tocItems.forEach(li => li.classList.remove('as-article-active'));

    if (currentHeadingId) {
      const activeItem = document.querySelector(
        `#as-article_menu .toc-${currentHeadingId}`
      );
      if (activeItem) {
        activeItem.classList.add('as-article-active');
      }
    }
  }

  document.addEventListener('scroll', onScrollHighlightTOC);
  window.addEventListener('load', onScrollHighlightTOC);

  // Accordion author bio
  const accordionBtn = document.querySelector(
    '#as-author_container .as-accordion'
  );
  if (accordionBtn) {
    accordionBtn.addEventListener('click', function () {
      this.classList.toggle('active');
      const panel = this.nextElementSibling;
      if (panel) {
        panel.classList.toggle('accordion-active');
        panel.classList.toggle('accordion-inactive');
      }
    });
  }
});
